import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTASection({
    eyebrow = "Ready When You Are",
    title = "Let's start a",
    accent = "conversation.",
    subtitle = "A 20-minute call clarifies more than ten brochures. No hard sell — just substance.",
    primaryLabel = "Book a Call",
    primaryHref = "/contact",
}) {
    return (
        <section className="section bg-[#1B2870] relative overflow-hidden" data-testid="cta-section">
            <div
                className="absolute inset-0 opacity-50 pointer-events-none"
                style={{
                    background:
                        "radial-gradient(ellipse at 30% 50%, rgba(200,160,100,0.18) 0%, transparent 55%)",
                }}
            />
            <div className="container-x relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
                <div className="lg:col-span-8">
                    <div className="flex items-center gap-3 mb-6">
                        <span className="h-px w-10 bg-[#C8A064]" />
                        <span className="overline">{eyebrow}</span>
                    </div>
                    <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#F3F4F6] leading-tight">
                        {title} <em className="text-[#C8A064] not-italic">{accent}</em>
                    </h2>
                    <p className="mt-6 text-[#94A3B8] max-w-xl leading-relaxed">{subtitle}</p>
                </div>
                <div className="lg:col-span-4 flex lg:justify-end">
                    <Link to={primaryHref} className="btn-brass" data-testid="cta-primary-link">
                        {primaryLabel} <ArrowRight size={16} />
                    </Link>
                </div>
            </div>
        </section>
    );
}
